
export function deleteForeignLegalRepresentativeData(foreignLegalRepresentativeDataRepository, foreignLegalRepresentativeDataId) {
  return foreignLegalRepresentativeDataRepository.delete(foreignLegalRepresentativeDataId);
}
